export default __webpack_public_path__ + "static/media/1.0b738b16.png";